import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { UseFormSetError } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../hooks/useGetHook";
import usePatchHook from "../../hooks/usePatchHook";
import CreateIcon from "../../icons/CreateIcon";
import Spinner from "../../shared/Spinner";
import { IComponent } from "../../types/interface";
import { queryClient } from "../../root.component";

const EditPageComponent = loadable(
  () => import("../../components/Components/Edit")
);

export default function EditComponent() {
  const { id } = useParams();

  const { data: componentInfo, isLoading: isGettingComponentInfo } =
    useGetHook<IComponent>({
      url: `${APIS.COMPONENT}${id}`,
      queryKey: ["component", `component-${id}`],
    });

  const { mutateAsync: updateComponent, isLoading: isUpdatingComponent } =
    usePatchHook({
      queryKey: ["component"],
      navigateURL: "",
    });

  const handleUpdate = async (
    data: IComponent,
    setError: UseFormSetError<IComponent>
  ): Promise<void> => {
    try {
      const url = `${APIS.COMPONENT}${id}/`;
      const res = await updateComponent({
        url,
        formData: {
          ...data,
        },
        setError,
      });
      if (res?.status === 200) {
        queryClient.refetchQueries();
      }
    } catch (error) {
      if (error instanceof Error) toast.error(error.message);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Update Components
        </span>
      </div>
      {isGettingComponentInfo ? (
        <Spinner />
      ) : (
        <EditPageComponent
          handleUpdate={handleUpdate}
          isUpdatingComponent={isUpdatingComponent}
          componentInfo={componentInfo}
        />
      )}
    </>
  );
}
